import type { Author } from '@/modules/Author/interface/Author';
import type { FC } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { Flex, Text } from '@eqi-investimentos/react';
import { PATHS } from '@/config/paths';

export const AuthorCard: FC<AuthorCardProps> = ({ name, slug, thumb }) => {
  return (
    <Flex
      as={Link}
      href={`${PATHS.hubs.author}/${slug}`}
      flexDir="column"
      alignItems="center"
      gap="3"
      maxW="7.5rem"
    >
      <Image
        src={thumb}
        alt={name}
        width={120}
        height={120}
        style={{
          minHeight: '7.5rem',
          maxHeight: '7.5rem',
          objectFit: 'cover',
          borderRadius: '50%',
        }}
        onError={({ currentTarget }) => {
          currentTarget.onerror = null;
          currentTarget.src = '/assets/eqi-placeholder.png';
        }}
      />
      <Text
        size="l"
        lineHeight="5"
        align="center"
        noOfLines={2}
        whiteSpace="pre-wrap"
      >
        {name}
      </Text>
    </Flex>
  );
};

type AuthorCardProps = Pick<Author, 'name' | 'slug' | 'thumb'>;
